(() => {
  if (!document.querySelector('#collection-grid, .nailarts-masters-pilot, #MainContent .slideshow.bannerSlider')) return;

  const navbar = document.querySelector('.header .navbar');
  if (!navbar) return;
  const productSection = document.querySelector('.nailarts-masters-pilot');

  let frame = 0;
  const update = () => {
    frame = 0;
    const pageTop = window.scrollY + navbar.getBoundingClientRect().top;
    navbar.style.setProperty('--nailarts-shadow-page-offset', `${-pageTop}px`);
    if (productSection) {
      const productTop = window.scrollY + productSection.getBoundingClientRect().top;
      productSection.style.setProperty('--nailarts-product-page-top', `${productTop}px`);
    }
  };
  const schedule = () => {
    if (!frame) frame = requestAnimationFrame(update);
  };

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('load', schedule);
  window.addEventListener('pageshow', schedule);
  document.fonts?.ready.then(schedule);
  update();
})();


(() => {
  const buttonSelector = '[data-nailarts-chat-button]';
  const getActivator = () => {
    const chat = document.querySelector('shopify-chat');
    const root = chat?.shadowRoot;
    return root?.querySelector('shopify-agent-runtime')?.shadowRoot?.querySelector('[part="activator"]') || root?.querySelector('[part="activator"]');
  };
  const sync = () => {
    if (document.querySelector(buttonSelector) && getActivator()) {
      document.documentElement.classList.add('nailarts-chat-header-ready');
      observer.disconnect();
      clearInterval(timer);
    }
  };
  const observer = new MutationObserver(sync);
  const timer = setInterval(sync, 300);
  document.addEventListener('click', event => {
    if (!event.target.closest(buttonSelector)) return;
    const chat = document.querySelector('shopify-chat');
    if (!chat || !getActivator()) return;
    event.stopPropagation();
    const shouldOpen = !chat.hasAttribute('open');
    chat.open = shouldOpen;
    const runtime = chat.shadowRoot?.querySelector('shopify-agent-runtime');
    if (runtime) runtime.open = shouldOpen;
  }, true);
  observer.observe(document.documentElement, { childList: true, subtree: true });
  sync();
})();
